module.exports = __webpack_public_path__ + "media/images/plan-detail__image-2@2x-e4c4853859433399b5be83859fea6fba.jpg";